var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logo-div"},[_c('span',{staticClass:"logo-title-name",class:{ pgray: !_vm.nightMode, 'text-light': _vm.nightMode }},[_c('b',[_vm._v("O")])]),_c('span',{staticClass:"logo-title-dot pblue"},[_vm._v(_vm._s(_vm.dot))])])
}
var staticRenderFns = []

export { render, staticRenderFns }